<template>
    <button class="plan-card" :class="selectedPlan === plan.id ? 'plan-card--active' : ''" @click.prevent="togglePlan()" :data-qa="plan.id">
        <div class="plan-card__indicator"></div>
        <div class="plan-card__content">
            <h3 class="text-base leading-tight mb-1" data-qa="plan-name">{{ planName }}</h3>
            <p class="text-lg font-sans font-normal mb-2" data-qa="plan-price"><span class="text-xl font-bold"><span v-text="$store.getters.currencyPrefix"></span>{{ calcMonthlyPrice() }}</span>/mo</p>
            <p class="text-s font-medium mb-2" v-if="$store.getters.isYearly">Paid yearly — <span v-text="$store.getters.currencyPrefix"></span>{{ priceFormat(planPricing) }}/yr</p>
            <p class="text-s mb-3" data-qa="plan-description">{{ planDescription }}</p>
            <p class="text-xs mt-auto font-medium">Includes <span data-qa="plan-included-contacts">{{ includedContacts }}</span> contacts, <span data-qa="plan-included-users">{{ includedUsers }}</span> users and 15 hrs of migration services</p>
        </div>
    </button>
</template>

<script>
import * as Analytics from '@/Util/reporting.js';
import { priceFormat } from '@/Util/helpers.js';

export default {
    props: {
        plan: Object
    },
    methods: {
        priceFormat,
        calcMonthlyPrice() {
            let price = this.planPricing;

            if (this.$store.getters.isYearly) {
                return Math.round((price / 12) * 100) / 100;
            }
            return price;
        },
        async togglePlan() {
            if (!this.selectionDisabled) {
                Analytics.pushToDataLayer({
                    event: 'click',
                    attributes: {
                        section: 'Choose your plan',
                        action: 'Selected Package',
                        event_label: this.plan.name,
                    },
                });

                this.selectedPlan = this.plan.id;

                if (this.$store.getters.hasFetchedEstimate && this.$store.getters.shouldFetchEstimate) {
                    await this.$store.dispatch('fetchEstimate');
                }
            }
        }
    },
    computed: {
        selectedPlan: {
            get() {
                return this.$store.getters.cartInfo.selectedPlanId;
            },
            set( value ) {
                this.$store.commit('updateCartInfo', { selectedPlanId: value });
            }
        },
        selectionDisabled() {
            if (this.$store.getters.isSoftLoading) {
                return true;
            }
        },
        planName() {
            return this.plan.metadata.title ?? this.plan.name;
        },
        planDescription() {
            return this.plan.metadata.description ?? this.plan.description;
        },
        planPricing() {
            const price = this.plan.pricing.find((price) => {
                return price.billingPeriodUnit === this.$store.getters.cartInfo.billingPeriod;
            }).tiers[0];

            return price.unitPrice / 100;
        },
        includedContacts() {
            const includedContacts = this.plan.addons.find((addon) => {
                return addon.type == 'mandatory' && addon.itemId.toLowerCase().includes('contact');
            });
            return includedContacts.quantity;
        },
        includedUsers() {
            const includedUsers = this.plan.addons.find((addon) => {
                return addon.type == 'mandatory' && addon.itemId.toLowerCase().includes('user');
            });
            return includedUsers.quantity;
        },
    },
};
</script>

<style lang="postcss" scoped>
.plan-card {
    @apply col-span-1 border-gray-4 border-2 rounded-medium p-3 pr-5 flex flex-row items-stretch gap-2;

    &__content {
        @apply text-left flex flex-col;
    }

    &__indicator {
        @apply w-[22px] h-[22px] rounded-full border-2 border-gray-4 relative bg-white flex justify-center items-center flex-shrink-0;

        &::after {
            content: '';
            @apply w-[12px] h-[12px] bg-green-default absolute rounded-full opacity-0;
        }
    }

    &--active {
        @apply border-green-default bg-green-10;

        .plan-card__indicator {
            @apply border-green-default;

            &::after {
                @apply opacity-100;
            }
        }
    }
}
</style>
